import React, { useState, useEffect } from "react";
import { createTheme, makeStyles } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/styles";
import Avatar from "@material-ui/core/Avatar";
import Grid from "@material-ui/core/Grid";
import EditIcon from "@material-ui/icons/Edit";
import { useHistory } from "react-router-dom";
import Cookies from "js-cookie";
import FileUploader from "../FileUploader/FileUploader";
const axios = require("axios");
const jwt = require("jsonwebtoken");

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  small: {
    width: theme.spacing(3),
    height: theme.spacing(3),
  },
  large: {
    width: theme.spacing(20),
    height: theme.spacing(20),
    fontSize: "8em",
    color: "white",
    backgroundColor: "#26477c",
  },
}));

const theme = createTheme({
  palette: {
    primary: { main: "#26477c" },
  },
});

const ImportTag = ({ currentOrganisation, setCurrentOrganisation }) => {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);
  let [userLists, setUserLists] = useState(false);
  let [userid, setUserID] = useState("");
  const [file, setFile] = useState(null);
  let history = useHistory();

  useEffect(() => {
    if (currentOrganisation !== "ntuGomic") {
      history.push("/dashboard/equipment");
    } else {
      setCurrentOrganisation(currentOrganisation);
    }
  }, []);

  return (
    <>
      <ThemeProvider theme={theme}>
        <Grid container spacing={1}>
          <Grid
            style={{
              display: "flex",
              justifyContent: "left",
              backgroundColor: "#26477c",
              padding: "8px",
              borderRadius: "8px",
            }}
            item
            xs={12}
          >
            <span style={{ fontSize: "1.2em", color: "white" }}>
              Import CSV
            </span>
          </Grid>
        </Grid>
      </ThemeProvider>
      <div>&nbsp;</div>
      <Grid container spacing={2}>
        <Grid item xs={1}></Grid>
        <Grid item xs={10}>
          <FileUploader />
        </Grid>
        <Grid item xs={1}></Grid>
      </Grid>
    </>
  );
};

export default ImportTag;
